import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import {
  Checkbox,
  Grid,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClassNameGenerator from "@mui/utils/ClassNameGenerator";
import moment from "moment";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import CustomButton from "../CommonComponents/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottomLe: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function CompanyUpdateModal(props) {
  const {
    button,
    title,
    width,
    rowData,
    openModal,
    setOpenModal,
    ExpencesData,
    companyData,
    companyListHandle,
    companyUsers,
    companyUserListHandle,
    oldUsers,
    approveUserHandle,
    fetchUserApprover,
    setCompanyUpadteId,
    companyUpdateId,
    AprroverUpdateId,
    setAprroverUpdateId,
    userId,
    setUserId,
    updateData,
    selectedApprover,
    updateUserHandler,
    deleteHandler,
    companyId,
    siteList,
    siteListHandle,
    siteId,
    isRestrictedToEndUser = false,
    setIsRestrictedToEndUser = () => {},
    isLoading = false,
    setIsLoading = () => {},
  } = props;
  console.log("selectedApprover at expense update: ", selectedApprover);
  const [open, setOpen] = React.useState(false);
  const [imageUrl, setImageUrl] = React.useState([]);
  const [isMultiLevelApproverEnabled, setIsMultiLevelApproverEnabled] =
    React.useState(false);
  const [multiLevelApproverArr, setMultiLevelApproverArr] = React.useState([
    { approver: null, isFinalApprover: false },
  ]);
  const [isSiteConfigEnableForCompany, setIsSiteConfigEnableForCompany] =
    React.useState(false);
  const [updateSiteData, setUpdateSiteData] = React.useState(null);
  console.log(
    "multiLevelApproverArr at expense update: ",
    multiLevelApproverArr,
  );
  console.log("updateData at expense update: ", updateData);
  const handleOpen = (data) => {
    setImageUrl(data);
    setOpen(true);
  };
  const handleClose = () => {
    setOpenModal(false);
    setIsRestrictedToEndUser(false);
  };

  const handleChangeMultiLevelApproverArr = ({
    multiApproverItemIndex,
    isAddingNewInstance = false,
    isItemUpdation = false,
    isMultiApproverItem = false,
    multiApproverItem,
    isFinalApproverCheck = false,
    finalApproverCheck,
  } = {}) => {
    setMultiLevelApproverArr((prevArr) => {
      if (isAddingNewInstance) {
        const newInstance = { approver: null, isFinalApprover: false };
        return [...prevArr, newInstance];
      }
      if (isItemUpdation) {
        return prevArr.map((item, index) => {
          if (index === multiApproverItemIndex) {
            const updatedItem = { ...item };

            if (isMultiApproverItem) {
              updatedItem.approver = multiApproverItem;
            }

            if (isFinalApproverCheck) {
              updatedItem.isFinalApprover = finalApproverCheck;
            }

            return updatedItem;
          }
          return item;
        });
      }

      return prevArr;
    });
  };

  const handleDeleteMultiLevelApproverArr = (multiApproverItemIndex) => {
    setMultiLevelApproverArr((prevArr) => {
      return prevArr?.filter((item, index) => index !== multiApproverItemIndex);
    });
  };

  React.useEffect(() => {
    if (openModal) {
      setMultiLevelApproverArr([{ approver: null, isFinalApprover: false }]);
      if (Boolean(updateData?.approverList?.length)) {
        setMultiLevelApproverArr(
          updateData?.approverList?.map((item) => ({
            approver: item?.approverId,
            isFinalApprover: item?.isFinal || false,
          })),
        );
      }
    }
  }, [openModal, updateData]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    // overflow: "hidden",
    // height: "50vh",
    overflow: "auto",
    padding: 3,
  };

  console.log(userId, "ExpencesData");

  // const defaultApprover =oldUsers &&  oldUsers.filter(ele => {
  //     return ele.id != updateData.approver.id
  // })

  const fetchCompanyWiseSiteList = async (foundCompanyId) => {
    const data = {
      companyId: foundCompanyId || null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
    };
    const res = await companyWiseEmp.getAllCompanyWiseSite(data);
    if (res !== null) {
      const result = (Array.isArray(res?.data) ? res?.data : [])?.find(
        (item) => item?.id === updateData?.user?.siteId,
      );
      setUpdateSiteData(result || null);
    } else {
      setUpdateSiteData(null);
    }
  };

  const FetchSaveMultiLevelApproverForUser = async () => {
    if (
      multiLevelApproverArr.some((approver) => !Boolean(approver?.approver?.id))
    ) {
      alert("All fields are mandatory!");
      return;
    }
    if (!multiLevelApproverArr.some((approver) => approver?.isFinalApprover)) {
      alert("Please select atleast one Final Approver!");
      return;
    }

    const payload = {
      hrmsCompanyId: updateData?.hrmsCompanyId || null,
      createdBy: { id: JSON.parse(localStorage.getItem("data")).id },
      companyName: companyUpdateId?.name || null,
      approverData: [
        {
          user: {
            id: updateData?.user?.id || null, // Assuming user ID is same for all approvers
          },
          approver:
            multiLevelApproverArr?.map((item, index) => {
              return {
                approverId: {
                  id: item?.approver?.id || null,
                },
                approverNo: index + 1,
                isFinal: item?.isFinalApprover || false,
              };
            }) || [],
        },
      ],
    };

    console.log(
      "payload for multi level approver at expense update: ",
      payload,
    );

    setIsLoading(true);

    const res = await companyWiseEmp?.saveMultiLevelApproverForComapny(payload);

    console.log("multi level approver res: ", res);
    if (res && res?.status === 200) {
      alert("Multi Level Approver added successfully");
      //   FetchMultiLevelApproverByCompanyId();
      if (isRestrictedToEndUser) {
        localStorage.setItem("holdApproverAtOdRestoreEmployee", true);
      }

      setIsLoading(false);
      window.location.reload(true);
    } else {
      // alert("Failed to save multi level approver");
      alert(res.response?.data?.responseDescription || res.message);
      setIsLoading(false);
    }
  };

  const FetchDeleteMultiLevelApproverForUser = async () => {
    const payload = {
      userId: updateData?.user?.id || null,
      hrmsCompanyId: updateData?.hrmsCompanyId || null,
    };

    const res =
      await companyWiseEmp?.deleteMultiLevelApproverForComapny(payload);

    console.log("multi level approver res: ", res);
    if (res && res?.status === 200) {
      alert("Multi Level Approver deleted successfully");
      //   FetchMultiLevelApproverByCompanyId();
      window.location.reload(true);
    } else {
      // alert("Failed to save multi level approver");
      alert(res.response?.data?.responseDescription || res.message);
    }
  };

  React.useEffect(() => {
    setIsMultiLevelApproverEnabled(
      updateData?.isMultiLevelApproverEnabled || false,
    );
  }, [updateData]);

  //   React.useEffect(() => {
  //     if (!openModal) {
  //       setIsMultiLevelApproverEnabled(false);
  //       setMultiLevelApproverArr([{ approver: null, isFinalApprover: false }]);
  //     }
  //   }, [openModal]);

  React.useEffect(() => {
    if (isSiteConfigEnableForCompany && updateData?.hrmsCompanyId) {
      fetchCompanyWiseSiteList(updateData?.hrmsCompanyId);
    }
  }, [updateData, isSiteConfigEnableForCompany]);

  React.useEffect(() => {
    if (Array.isArray(companyData)) {
      const approverDataByCompanyID = companyData?.filter((ele) => {
        return updateData?.hrmsCompanyId == ele.id;
      });

      if (
        Array.isArray(approverDataByCompanyID) &&
        approverDataByCompanyID.length > 0
      ) {
        setIsSiteConfigEnableForCompany(
          approverDataByCompanyID[0]?.isSiteConfigEnabled || false,
        );
      } else {
        setIsSiteConfigEnableForCompany(false);
      }
    } else {
      setIsSiteConfigEnableForCompany(false);
    }
  }, [companyData, updateData]);

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "5px" }}
              //</ModalBody> alignItems="center"
            >
              {isRestrictedToEndUser ? (
                ""
              ) : (
                <>
                  <Grid item xs={2}>
                    Company*
                  </Grid>
                  <Grid item xs={8}>
                    <CustomAutoComplete
                      disablePortal
                      id="company"
                      disabled
                      options={(companyData !== undefined && companyData) || []}
                      // getOptionLabel={(option) => option.companyName}
                      getOptionLabel={(designation) =>
                        designation.companyName
                          ? designation.companyName
                          : companyUpdateId
                      }
                      getOptionSelected={(option, value) =>
                        option.companyName ===
                        (value != null && value.companyName != null
                          ? value.companyName
                          : "")
                      }
                      filterSelectedOptions
                      value={companyUpdateId}
                      sx={{ width: "auto" }}
                      onChange={(value, newVal) => companyListHandle(newVal)}
                      renderInput={(params) => (
                        <TextField {...params} label="Company" />
                      )}
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>

            {!isRestrictedToEndUser && isSiteConfigEnableForCompany ? (
              <Grid
                xs={12}
                container
                direction="row"
                justifyContent="flex-start"
                sx={{ marginTop: "5px" }}
                //</ModalBody> alignItems="center"
              >
                <Grid item xs={2}>
                  Site*
                </Grid>
                <Grid item xs={8}>
                  <CustomAutoComplete
                    disablePortal
                    id="site"
                    disabled
                    options={(siteList !== undefined && siteList) || []}
                    // getOptionLabel={(option) => option.companyName}
                    getOptionLabel={(designation) =>
                      designation.name ? designation.name : siteId?.name
                    }
                    getOptionSelected={(option, value) =>
                      option.name ===
                      (value != null && value.name != null ? value.name : "")
                    }
                    filterSelectedOptions
                    value={updateSiteData || null}
                    sx={{ width: "auto" }}
                    onChange={(value, newVal) => siteListHandle(newVal)}
                    renderInput={(params) => (
                      <TextField {...params} label="Site" />
                    )}
                    size="small"
                  />
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "10px" }}
              //</ModalBody> alignItems="center"
            >
              <Grid item xs={2}>
                Company User*
              </Grid>
              <Grid item xs={8}>
                <CustomAutoComplete
                  disablePortal
                  id="user"
                  disabled
                  options={companyUsers || []}
                  getOptionLabel={(designation) =>
                    designation.name ? designation.name : userId
                  }
                  getOptionSelected={(option, value) =>
                    option.name ===
                    (value != null && value.name != null ? value.name : "")
                  }
                  filterSelectedOptions
                  onChange={(value, newVal) => companyUserListHandle(newVal)}
                  sx={{ width: "auto" }}
                  value={userId}
                  renderInput={(params) => (
                    <TextField {...params} label="Company Users" />
                  )}
                  size="small"
                />
              </Grid>
            </Grid>
            {/* <Grid
                            xs={12}
                            container
                            direction="row"
                            justifyContent="flex-start"
                            sx={{ marginTop: "10px" }}
                        //</ModalBody> alignItems="center"
                        >
                            <Grid item xs={2}>
                                Approver*
                            </Grid>
                            <Grid item xs={8}>
                                <CustomAutoComplete
                                    disablePortal
                                    id="user"
                                    // disabled={oldUsers && oldUsers.length > 0 ? false : true}
                                    options={selectedApprover && selectedApprover === [] ? [] : selectedApprover}
                                    // getOptionLabel={(option) => option.name}
                                    getOptionLabel={({ name, empCode }) => {
                                        return `${name} (${empCode})`;
                                    }}
                                    // defaultValue={defaultApprover}
                                    onChange={(value, newVal) => setAprroverUpdateId(newVal)}
                                    sx={{ width: "auto" }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Approver" />
                                    )}
                                    size="small"
                                />
                            </Grid>
                        </Grid> */}
            {isMultiLevelApproverEnabled ? (
              <>
                {Boolean(multiLevelApproverArr?.length) && (
                  <>
                    {multiLevelApproverArr?.map(
                      (item, multiLevelApproverIndex) => {
                        return (
                          <Grid
                            key={multiLevelApproverIndex}
                            container
                            sx={{ marginTop: "10px" }}
                            spacing={2}
                          >
                            <Grid item xs={2}>
                              {`Approver ${multiLevelApproverIndex + 1}*`}
                            </Grid>

                            <Grid item xs={6} md={6.5}>
                              <CustomAutoComplete
                                size="small"
                                id="multiple-limit-tags"
                                value={
                                  selectedApprover?.find(
                                    (approverItem) =>
                                      approverItem?.id === item?.approver?.id,
                                  ) || null
                                }
                                options={
                                  selectedApprover?.filter(
                                    (item) =>
                                      !multiLevelApproverArr?.some(
                                        (approver) =>
                                          approver?.approver?.id === item?.id,
                                      ),
                                  ) || []
                                }
                                // isOptionEqualToValue={(option, value) =>
                                //   option.id === value?.id
                                // }
                                getOptionLabel={(option) =>
                                  `${option?.name}(${option?.empCode})`
                                }
                                disablePortal
                                onChange={(event, newValue) => {
                                  handleChangeMultiLevelApproverArr({
                                    multiApproverItemIndex:
                                      multiLevelApproverIndex,
                                    isItemUpdation: true,
                                    isMultiApproverItem: true,
                                    multiApproverItem: newValue,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder={`Approver ${
                                      multiLevelApproverIndex + 1
                                    }*`}
                                  />
                                )}
                              />
                            </Grid>

                            <Grid item xs={2.5} md={1}>
                              <Tooltip
                                arrow
                                title="Final Approver"
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "offset",
                                      options: {
                                        offset: [0, -10],
                                      },
                                    },
                                  ],
                                }}
                              >
                                <Checkbox
                                  disabled={
                                    !Boolean(item?.approver)
                                    // || (multiLevelApproverArr.some(
                                    //   (approver) => approver.isFinalApprover
                                    // ) &&
                                    //   !item.isFinalApprover)
                                  }
                                  checked={item?.isFinalApprover || false}
                                  onChange={(e) =>
                                    handleChangeMultiLevelApproverArr({
                                      isItemUpdation: true,
                                      isFinalApproverCheck: true,
                                      multiApproverItemIndex:
                                        multiLevelApproverIndex,
                                      finalApproverCheck: e.target.checked,
                                    })
                                  }
                                  color="primary"
                                />
                              </Tooltip>
                            </Grid>
                            {Boolean(multiLevelApproverIndex) && (
                              <Grid item xs={1}>
                                <Tooltip
                                  arrow
                                  title="Remove Approver"
                                  PopperProps={{
                                    modifiers: [
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, -8],
                                        },
                                      },
                                    ],
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      bgcolor: "#ef2222",
                                      color: "white",
                                      "&:hover": { bgcolor: "#cf0f0f" },
                                    }}
                                    onClick={() =>
                                      handleDeleteMultiLevelApproverArr(
                                        multiLevelApproverIndex,
                                      )
                                    }
                                  >
                                    <DeleteIcon sx={{ fontSize: "18px" }} />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            )}
                          </Grid>
                        );
                      },
                    )}
                    <Grid container spacing={2} sx={{ marginTop: "10px" }}>
                      <Grid item xs={10.5} md={9.5}></Grid>
                      <Grid item xs={1}>
                        <Tooltip
                          arrow
                          title="Add Another Approver"
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -8],
                                },
                              },
                            ],
                          }}
                        >
                          <IconButton
                            sx={{
                              bgcolor: "#05a4f4",
                              color: "white",
                              "&:hover": { bgcolor: "#0489cc" },
                            }}
                            onClick={() =>
                              handleChangeMultiLevelApproverArr({
                                isAddingNewInstance: true,
                              })
                            }
                          >
                            <AddIcon sx={{ fontSize: "18px" }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            ) : (
              <>
                <Grid
                  xs={12}
                  container
                  direction="row"
                  justifyContent="flex-start"
                  sx={{ marginTop: "10px" }}
                  //</ModalBody> alignItems="center"
                >
                  <Grid item xs={2}>
                    Approver*
                  </Grid>
                  <Grid item xs={8}>
                    <CustomAutoComplete
                      disablePortal
                      id="user"
                      // disabled={oldUsers && oldUsers.length > 0 ? false : true}
                      options={
                        selectedApprover && selectedApprover === []
                          ? []
                          : selectedApprover
                      }
                      // getOptionLabel={(option) => option.name}
                      getOptionLabel={({ name, empCode }) => {
                        return `${name} (${empCode})`;
                      }}
                      // defaultValue={defaultApprover}
                      onChange={(value, newVal) => setAprroverUpdateId(newVal)}
                      sx={{ width: "auto" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Approver" />
                      )}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </ModalBody>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            sx={{ marginTop: "190px" }}
            spacing={4}
          >
            <Grid item>
              <CustomButton
                name={"Delete User"}
                onClick={deleteHandler}
                sx={{ margin: "10px" }}
              />
            </Grid>
            <Grid item>
              <CustomButton
                name={"Update User"}
                onClick={
                  updateData?.isMultiLevelApproverEnabled
                    ? FetchSaveMultiLevelApproverForUser
                    : updateUserHandler
                }
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
